import { FC } from "react";
import LockedIcon from "@mui/icons-material/Lock";
import UnlockedIcon from "@mui/icons-material/LockOpen";

interface Props {
	flag?: boolean;
	size?: "inherit" | "large" | "medium" | "small";
}

/**
 * LockedIndicator renders a "locked" icon according to the input flag.
 *
 * @param flag
 * @param size
 * @constructor
 */
const LockedIndicator: FC<Props> = ({ flag, size }) => {
	return flag ? <LockedIcon fontSize={size} color="error" /> : <UnlockedIcon fontSize={size} color="primary" />;
};

export default LockedIndicator;
